import React from 'react';

export interface ProgressBarProps {
    currentStep: number;
    totalSteps: number;
}

/**
 * Progress bar component for multi-step flows
 * Displays horizontal progress indicators matching the onboarding design
 */
const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps }) => {
    return (
        <div className="flex items-center gap-2 w-full">
            {Array.from({ length: totalSteps }, (_, index) => (
                <div
                    key={index}
                    className={`
            h-1 flex-1 rounded-full transition-colors duration-300
            ${index < currentStep ? 'bg-[#00A8E8]' : 'bg-gray-200'}
          `}
                />
            ))}
        </div>
    );
};

export default ProgressBar;
